<template>
  <div :class="ns.e('virtual-container')" :style="{ height: `${totalSize}px` }">
    <grid-tree-virtual-row
      v-for="virtualRow in virtualRows"
      :key="rowKey(tableData[virtualRow.index], virtualRow.index)"
      :row="tableData[virtualRow.index]"
      :index="virtualRow.index"
      :virtual-start="virtualRow.start"
      :columns="columns"
      :row-height="rowHeight"
      :table-width="tableWidth"
      :seq-label="virtualRow.index + 1"
      @click="onRowClick"
      @dblclick="onRowDblClick"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'
import { useNamespace } from '@zoryn/hooks'
import { beginRowEdit } from '@zoryn/components/grid/src/methods/edit'
import { resolveGridEditable } from '@zoryn/components/grid/src/column/meta'
import { getRowId } from '@zoryn/components/grid/src/utils/row-id'
import GridTreeVirtualRow from './grid-tree-virtual-row.vue'
import type { DataGridTree, GridColumnInfo } from '../types'

const props = defineProps<{
  columns: GridColumnInfo[]
  virtualRows: Array<{ index: number; start: number }>
  totalSize: number
  rowHeight: number
  tableWidth: number
}>()

const ns = useNamespace('grid')
const $grid = inject('$grid') as DataGridTree
const { reactData, props: gridProps } = $grid

const tableData = computed(() => reactData.tableData)
const tableEditable = computed(() => resolveGridEditable(gridProps, $grid.options))

function rowKey(row: Record<string, unknown>, index: number) {
  return getRowId(row, index)
}

function onRowClick(row: Record<string, unknown>) {
  $grid.setCurrentRow(row)
}

function onRowDblClick(row: Record<string, unknown>) {
  if (!tableEditable.value) {
    return
  }
  if (!beginRowEdit($grid as never, row)) {
    return
  }
  $grid.setCurrentRow(row)
}
</script>
